import { render, staticRenderFns } from "./openCustomers.vue?vue&type=template&id=bea06ffa&scoped=true&"
import script from "./openCustomers.vue?vue&type=script&lang=js&"
export * from "./openCustomers.vue?vue&type=script&lang=js&"
import style0 from "./openCustomers.vue?vue&type=style&index=0&id=bea06ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea06ffa",
  null
  
)

export default component.exports